import { axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls, filterValuesTypes } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import getValidationErrors from './getValidationErrors'
import displayError from 'shared/utils/displayError'

interface updateRowInlineProps {
  row: any,
  setShowOverlay: Function,
  setRows: Function,
}

const updateRowInline = async (props: updateRowInlineProps) => {
  let response: any = false

  const matchedType = filterValuesTypes.find(item => item.name === props.row.type)

  const transformedType = matchedType ? matchedType.id : null

  const formData = {
    ...props.row,
    type: transformedType
  }

  const catchFunc = async (err: AxiosError) => {
    if (err.response!.status === 422) {
      const errors = getValidationErrors(err)
      displayError({ errorMessage: errors[0] ?? 'An errror occurred', setShowOverlay: props.setShowOverlay, scrollTop: false })
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  response = await axiosPut(apiUrls.filterValues + '/' + props.row.id, formData, catchFunc)

  if(response !== undefined && (response.status === 200 || response.status === 201)){
    props.setRows(prev =>
      prev.map(row =>
        row.id === props.row.id
          ? { ...props.row }
          : row
      )
    )
  }


}

export default updateRowInline
